import script from "./Widgets.vue?vue&type=script&setup=true&lang=js"
export * from "./Widgets.vue?vue&type=script&setup=true&lang=js"

import "./Widgets.vue?vue&type=style&index=0&id=9f4de942&lang=scss"

const __exports__ = script;

export default __exports__